import { render, staticRenderFns } from "./ClassSection.vue?vue&type=template&id=44038b82&scoped=true"
import script from "./ClassSection.vue?vue&type=script&lang=js"
export * from "./ClassSection.vue?vue&type=script&lang=js"
import style0 from "./ClassSection.vue?vue&type=style&index=0&id=44038b82&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44038b82",
  null
  
)

export default component.exports